<template>
    <div class="examine-notice-detail">
        <div class="examin-notice-box">
            <div class="widthPC-90 margin-x-auto">
            <table class="detail-table" border="1" cellspacing="0" cellpadding="0" v-if="pageType ==1">
                <tr>
                    <th colspan="3">联系人</th>
                </tr>
                <tr>
                    <td class="font-bold">角色：</td>
                    <td colspan="2">{{ baseInfo.projectRole }}</td>
                </tr>
                <tr>
                    <td class="font-bold">单位名称：</td>
                    <td>{{baseInfo.companyName}}</td>
                </tr>
                <tr>
                    <td class="font-bold">单位地址：</td>
                    <td>{{baseInfo.province}}- {{baseInfo.city}} </td>
                </tr>
                <tr>
                    <td class="font-bold">办公电话：</td>
                    <td>{{ baseInfo.companyTel || '-'}}</td>
                </tr>
                <tr>
                    <td class="font-bold">联系人：</td>
                    <td>{{ baseInfo.contactPerson || '-' }}</td>
                </tr>
                <tr>
                    <td class="font-bold">联系方式：</td>
                    <td>{{ baseInfo.contactDetails || '-' }}</td>
                </tr>
            </table>
            <table class="detail-table" border="1" cellspacing="0" cellpadding="0" v-for="list in contactList" :key="list.id" v-if="pageType == 2">
                <tr>
                    <th colspan="3">联系人</th>
                </tr>
                <tr>
                    <td class="font-bold">联系人：</td>
                    <td>{{ list.contactPerson || '-' }}</td>
                </tr>
                <tr>
                    <td class="font-bold">角色：</td>
                    <td colspan="2">{{ list.projectRole }}</td>
                </tr>
                <tr>
                    <td class="font-bold">单位名称：</td>
                    <td>{{list.companyName}}</td>
                </tr>
                <tr>
                    <td class="font-bold">单位地址：</td>
                    <td>{{list.province}}- {{list.city}} </td>
                </tr>
                <tr>
                    <td class="font-bold">办公电话：</td>
                    <td>{{ list.companyTel || '-'}}</td>
                </tr>
                <tr>
                    <td class="font-bold">联系方式：</td>
                    <td>{{ list.contactDetails || '-' }}</td>
                </tr>
            </table>
            <!-- <div class="detail-content" v-if="baseInfo.content" v-html="baseInfo.content"></div> -->
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            id: this.$route.query.id || null,
            pageType: this.$route.query.type || 1, 
            contactList: [],
            baseInfo: {
                fileNo: '',
                projectName: '',
                projectCode: '',
                approvalUnit: '',
                type: '',
                title: '',
                completionDate: ''
            },
        }
    },
    created() {

    },
    mounted() {
        this.getData();
    },
    methods: {


        getData() {
            let ajaxUrl = '';
            if(this.pageType == 1){
                ajaxUrl = this.$api.common.contact.Detail() + '?id=' + this.id;
            }else if(this.pageType == 2){
                ajaxUrl = this.$api.common.contact.DetailList() + '?companyName=' + this.id;
            }
            this.$axios.get(ajaxUrl).then((res) => {
                console.log('联系人详情', res);
                if(this.pageType == 1){
                   this.baseInfo = res.data || {};
                }else if(this.pageType == 2){
                    this.contactList = res.list || [];
                }
                
            }).catch((err) => { });x

        }
    }
}
</script>

<style lang="less" scoped>
.examin-notice-box {
    padding: 20px;
    width: 100%;
    background: #fff;
}
.fileNo {
    font-size: 20px;
    color: #666;
}
.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th {
        background: #f1f8ff;
        text-align: center;
    }

    th,
    td {
        padding: 10px;
        border: 1px solid #eee;
        min-width: 150px;
    }
}
.detail-content{
    margin-top: 20px;
    padding: 10px;
    line-height: 3;
    border: 1px solid #ebf1f5;
    box-shadow: 0 2px 4px #ebf1f5;
}
</style>